import React, { useEffect, createRef, useState } from 'react';
import styles from './YouTubeSubscribeButton.module.scss';

const YouTubeSubscribeButton = ({
  count,
  channel,
}: {
  count: string;
  channel: string;
}) => {
  const subscibeRef: React.RefObject<any> = createRef();
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (initialized) {
      return;
    }

    const youtubeScript = document.createElement('script');
    youtubeScript.src = 'https://apis.google.com/js/platform.js';

    subscibeRef.current.parentNode.appendChild(youtubeScript);
    setInitialized(true);
  }, [initialized, subscibeRef]);

  return (
    <section className={styles.youtubeSubscribe}>
      <div
        ref={subscibeRef}
        className="g-ytsubscribe"
        data-count={count}
        data-channel={channel}
      />
    </section>
  );
};

export default YouTubeSubscribeButton;
